import Link from "next/link";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";


export function UsageTable() {
  return (
    <div className="mt-20">
      <h3 className="mb-2 text-2xl font-semibold">Usage-based pricing</h3>
      <p className="mb-8 text-sm text-muted-foreground">
        Pay only for what you use. All plans include monthly usage credits.
      </p>

      <div className="rounded-lg border bg-card p-6">
      <h4 className="mb-4 text-lg font-semibold">Moondream 3 (Preview)</h4>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[140px]" />
            <TableHead className="w-[160px]" />
            <TableHead className="w-[140px]">Input (1M tokens)</TableHead>
            <TableHead className="w-[140px]">Output (1M tokens)</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow>
            <TableCell rowSpan={2} className="align-top font-medium">
              Real-time
            </TableCell>
            <TableCell className="text-muted-foreground">Base model</TableCell>
            <TableCell className="tabular-nums">$0.3000</TableCell>
            <TableCell className="tabular-nums">$2.5000</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-muted-foreground">
              <div className="flex items-center gap-2">
                Finetune
                <span className="rounded-full bg-muted px-1.5 py-0.5 text-xs font-medium text-muted-foreground">
                  +25%
                </span>
              </div>
            </TableCell>
            <TableCell className="tabular-nums">$0.3750</TableCell>
            <TableCell className="tabular-nums">$3.1250</TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan={2} className="align-top font-medium">
              <div className="flex items-center gap-2">
                Batch
                <span className="rounded-full bg-muted px-1.5 py-0.5 text-xs font-medium text-muted-foreground">
                  -50%
                </span>
              </div>
            </TableCell>
            <TableCell className="text-muted-foreground">Base model</TableCell>
            <TableCell className="tabular-nums">$0.1500</TableCell>
            <TableCell className="tabular-nums">$1.2500</TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-muted-foreground">
              <div className="flex items-center gap-2">
                Finetune
                <span className="rounded-full bg-muted px-1.5 py-0.5 text-xs font-medium text-muted-foreground">
                  +25%
                </span>
              </div>
            </TableCell>
            <TableCell className="tabular-nums">$0.1875</TableCell>
            <TableCell className="tabular-nums">$1.5625</TableCell>
          </TableRow>
          <TableRow>
            <TableCell rowSpan={2} className="align-top font-medium">
              <div className="flex items-center gap-2">
                Finetuning
                <span className="rounded-full bg-primary/10 px-1.5 py-0.5 text-xs font-medium text-primary">
                  Free during preview
                </span>
              </div>
            </TableCell>
            <TableCell className="text-muted-foreground">Rollout generation</TableCell>
            <TableCell className="tabular-nums">
              <span className="text-muted-foreground line-through">$0.3000</span>{" "}
              Free
            </TableCell>
            <TableCell className="tabular-nums">
              <span className="text-muted-foreground line-through">$2.5000</span>{" "}
              Free
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className="text-muted-foreground">Training</TableCell>
            <TableCell className="tabular-nums">
              <span className="text-muted-foreground line-through">$2.5000</span>{" "}
              Free
            </TableCell>
            <TableCell className="text-muted-foreground">—</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      </div>

      <p className="mt-6 text-base">
        Each image consumes 729 tokens. Text is
        tokenized using a{" "}
        <Link
          href="/blog/moondream-2025-06-21-release#faster-text-generation"
          className="underline"
        >
          superword tokenizer
        </Link>
        . Try the{" "}
        <Link
          href="/playground"
          className="underline"
        >
          playground
        </Link>{" "}
        to see token usage for your requests.
      </p>
    </div>
  );
}
